const body = document.querySelector('body');
const mobileMenuButton = document.getElementById('main_nav_button');
const mainNav = document.getElementById('main_nav');
const siteHeader = document.getElementById('site_header');


/**
 *
 *
 *
 */
const init = function() {

	if ( mainNav !== null ) {
		mobileMenuButton.addEventListener('click', () => {
			checkBodyForVisibilityClass();
		})
	}

};


/**
 *
 *
 *
 */
const trapFocus = function(e) {

	const focusableEls = this.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	const firstFocusableEl = focusableEls[0];
	const lastFocusableEl = focusableEls[focusableEls.length - 1];
	const KEYCODE_TAB = 9;
	const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

	if (!isTabPressed) {
		return;
	}

	if ( e.shiftKey ) /* shift + tab */ {
		if (document.activeElement === firstFocusableEl) {
			lastFocusableEl.focus();
			e.preventDefault();
		}
	} else /* tab */ {
		if (document.activeElement === lastFocusableEl) {
			firstFocusableEl.focus();
			e.preventDefault();
		}
	}

}


/**
 *
 *
 *
 */
const checkBodyForVisibilityClass = function() {

	if ( body.classList.contains('mobile-menu-visible') ) {
		toggleMobileMenu('hide');
	} else {
		toggleMobileMenu('show');
	}

};


/**
 * Shows or hides the mobile by modifying classes & aria
 * attributes.
 *
 * @param state String "Show" to show the menu, anything else to hide
 * @return none
 *
 */
const toggleMobileMenu = function(state) {

	var bodyActiveClass = 'mobile-menu-visible';
	var menuActiveClass = 'is-active';

	if ( state === 'show' ) {

		siteHeader.addEventListener('keydown', trapFocus);
		body.classList.add(bodyActiveClass);
		mobileMenuButton.classList.add(menuActiveClass);
		mobileMenuButton.setAttribute('aria-expanded', 'true');
		mainNav.removeAttribute('hidden');

	} else {

		siteHeader.removeEventListener('keydown', trapFocus, true);
		body.classList.remove(bodyActiveClass);
		mobileMenuButton.classList.remove(menuActiveClass);
		mobileMenuButton.setAttribute('aria-expanded', 'false');
		mainNav.setAttribute('hidden', 'hidden');

	}

};


const api = {
	init: init
};

export default api;